var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"swiperCategory",staticClass:"CategorySlider",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.categories),function(ref){
var name = ref.name;
var icon = ref.icon;
return _c('swiper-slide',{key:name},[_c('CategoryItem',{attrs:{"name":name,"active":name === _vm.activeCategory},nativeOn:{"click":function($event){return _vm.setCategory(name)}}},[_c('img',{staticClass:"-scale-x-1 transform",attrs:{"src":icon,"alt":name}})])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }